function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.49805 12.8185C2.49805 7.28848 6.96805 2.81848 12.498 2.81848C18.028 2.81848 22.498 7.28848 22.498 12.8185C22.498 18.3485 18.028 22.8185 12.498 22.8185C6.96805 22.8185 2.49805 18.3485 2.49805 12.8185ZM16.088 17.8185L17.498 16.4085L13.908 12.8185L17.498 9.22848L16.088 7.81848L12.498 11.4085L8.90805 7.81848L7.49805 9.22848L11.088 12.8185L7.49805 16.4085L8.90805 17.8185L12.498 14.2285L16.088 17.8185Z",
  fill: "#CCCCCC"
});
const SvgEncircledCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEncircledCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/encircled-cross.a551e82d.svg";
export { ForwardRef as ReactComponent };